module.exports = __webpack_public_path__ + "img/partnersOne.e6112f2d.png";